import React, { useEffect, useState } from "react";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import Table from "../ui/VirtualTable";
import Space from "../ui/Space";
import Nav from "../ui/Nav";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";

export default function GLAccounts(props) {

    const { controller = "", route = "", search = "", callback = () => { } } = props;

    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});

    const nav = [
        { text: "Del" },
        { text: "Edt" },
        { text: "New" },
        { text: "Prt" },
    ]

    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback(false) } },
            { key: KBD.ENTER, action: (e) => { callback(selected) } },
        ];
        const cleanup = listen(controller, route, actions.concat(nav));
        return cleanup;
    }, [nav, selected])

    const isYes = (_bool) => {
        return (_bool) ? <small style={{ "color": "var(--text)" }}>Yes</small> : <small style={{ "color": "var(--text-dim)" }}>No</small>;
    }

    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const nextIndex = data.findIndex(item => item?.account === selected?.account) + _rows;
        if (data.length <= nextIndex) { setSelected(data[0]); }
        if (nextIndex < data.length) { setSelected(data[nextIndex]); }
    };
    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.account === selected?.account) - _rows;
        if (prevIndex < 0) { setSelected(data[data.length - 1]); return; }
        if (prevIndex >= 0) { setSelected(data[prevIndex]); }
    };

    const getIndex = (_search = "", _data) => {
        if (!_search) {
            return 0;
        }
        let _index = _data.findIndex(obj => {
            const accountNumber = obj.account.toString();
            return accountNumber.startsWith(_search.toString());
        });

        return _index; 
    }

    const columns = [
        { key: "account", align: "center", title: <>Account</>, width: 55 },
        { key: "description", align: "left", title: <>Description</>, width: 350 },
        { key: "reserved", align: "left", title: <>Resrvd</>, width: 48, render: (e) => isYes(e) },
        { key: "entry_section", align: "left", title: <>Se</>, width: 35, render: (e) => isYes(e) },
        { key: "entry_location", align: "left", title: <>Lo</>, width: 35, render: (e) => isYes(e) },
        { key: "statement_section", align: "left", title: <>Se</>, width: 35, render: (e) => isYes(e) },
        { key: "statement_location", align: "left", title: <>Lo</>, width: 35, render: (e) => isYes(e) },
        { key: "quick_book", align: "left", title: <>Se</>, width: 82, render: (e) => isYes(e) },
    ]

    const getAllAccounts = () => {
        pubCall("general_ledger.getAllAccounts", {}, (_s, _r) => {
            if (_s) {
                setData(_r);
                let _index = getIndex(search, _r); 
                setSelected(_r.length > 0 ? _r[_index] : {});
            } else {
                showError(_r);
            }
        })
    }

    useEffect(getAllAccounts, [])

    const drawHeader = () => {
        return (
            <Space>
                <div style={{ "width": "460px" }}></div>
                <div className="ReactVirtualized__Table__headerColumn">&nbsp;</div>
                <div style={{ "width": "75px", "justifyContent": "start" }} className="ReactVirtualized__Table__headerColumn">Entries</div>
                <div style={{ "width": "75px", "justifyContent": "start" }} className="ReactVirtualized__Table__headerColumn">Statements</div>
                <div style={{ "width": "70px", "justifyContent": "start" }} className="ReactVirtualized__Table__headerColumn">Quickbooks</div>
            </Space>
        )
    }

    return (
        <>
            <div className="shim" /><div className="shim" />
            <Table
                controller={controller}
                header={drawHeader()}
                onWheel={(e) => (e.deltaY > 0) ? next() : prev()}
                onRowClick={(item, event, index) => setSelected(item)}
                onRowDoubleClick={(item) => callback(item)}
                next={next}
                prev={prev}
                row_key="account"
                align="auto"
                tweak={60}
                route={route}
                current={selected}
                offset={0}
                height={388}
                data={data}
                columns={columns}
                width={762}
            />

            <div style={{ "marginTop": "5px" }}><Nav nav={nav} /></div>
        </>
    )
}